import { render, staticRenderFns } from "./TitleOverlay.vue?vue&type=template&id=26768b54&"
import script from "./TitleOverlay.vue?vue&type=script&lang=js&"
export * from "./TitleOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports